module.exports = __webpack_public_path__ + "media/images/img_consul_2-8bfee6809f4fe0fa145e1c27b44bdfa4.jpg";